import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Table from 'views/reports/registeredDocuments/recordTable'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration
import { getDocumentFileError, getNextVersion } from 'helpers/registeredDocumentFile'; // Same file validation and version as the edit popup

/**
 * Class representing the record deposit reports view.
 * @extends JetView
 */
export default class recordDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerV', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };
        let id = ''; // Variable to store the document ID
        let name = ''; // Document name, passed back on reload so the versions table keeps it
        let version = ''; // Current version, the new one is the next consecutive
        let encryption = ''; // Current EncryptionValue, preloaded in the Encriptación field
        let encryptionMethod = ''; // EncryptionMethod from GetDocuments, sent unchanged
        this.on(this.app, 'version:id', (Id, Name, Version, EncryptionValue, EncryptionMethod) => {
            // Event listener for version ID
            id = Id; // Assigning received ID to variable
            name = Name;
            version = Version;
            encryption = EncryptionValue;
            encryptionMethod = EncryptionMethod;
        });
        // Version added from the edit popup: keeps the current version of this document up to date
        this.on(this.app, 'registeredDocument:versionAdded', (Id, Version) => {
            if (String(Id) === String(id)) {
                version = Version;
            }
        });
        const app = this.app; // Used to reload the versions table after adding one
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying theme CSS
                    elements: [
                        {
                            view: 'label', // Label for the toolbar
                            label: _('Versiones'), // Localized label text
                            align: 'center', // Center alignment
                        },
                        {
                            view: 'button', // Button to add a version
                            value: _('Añadir Versión'), // Localized button text
                            hidden: !devConfig.getPermAction('registeredDocumentAddVersion', 'Add'), // Conditional visibility
                            css: 'prm-registeredDocumentAddVersion',
                            type: 'form', // Button type
                            width: 200, // Button width
                            click: () => {
                                // Click event handler
                                var fileBase64 = ''; // Base64 content (data URI) of the selected file, sent as File like AddDocument
                                webix
                                    .ui({
                                        // Creating a new window UI
                                        view: 'window',
                                        width: 400,
                                        head: {
                                            view: 'toolbar', // Toolbar for the window header
                                            cols: [
                                                {
                                                    view: 'label', // Label for the window
                                                    label: _('Añadir Versión'), // Localized label text
                                                },
                                                {
                                                    view: 'icon', // Close icon for the window
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        // Click event to close the window
                                                        this.getTopParentView().hide(); // Hides the window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center', // Center position of the window
                                        modal: true, // Modal window
                                        on: {
                                            onHide: function () {
                                                this.close(); // Destroyed on hide, since a new window is created on each click
                                            },
                                        },
                                        body: {
                                            view: 'form', // Form inside the window
                                            id: 'addVersion', // Unique identifier for the form
                                            elements: [
                                                {
                                                    view: 'text', // Preloaded with the current encryption, editable but not empty
                                                    label: _('Encriptación'),
                                                    name: 'EncryptionValue',
                                                    value: encryption || '',
                                                    required: true,
                                                    labelWidth: 120, // Label width
                                                },
                                                {
                                                    view: 'uploader', // File picker for the version document, replaces the document URL
                                                    id: 'VersionFile',
                                                    value: _('Cargar Archivo'),
                                                    multiple: false,
                                                    autosend: false,
                                                    accept: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
                                                    label: _('Archivo'),
                                                    labelWidth: 120, // Label width
                                                    on: {
                                                        // Validates extension and size (max 5.000 KB) before adding the file;
                                                        // on error, clears the current selection and cancels the add.
                                                        onBeforeFileAdd: function (uploadedFile) {
                                                            var errorText = getDocumentFileError(uploadedFile, _);
                                                            if (errorText) {
                                                                fileBase64 = '';
                                                                this.files.clearAll();
                                                                $$('VersionFileNameLabel').setHTML('');
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: errorText,
                                                                });
                                                                return false;
                                                            }
                                                            return true;
                                                        },
                                                        onAfterFileAdd: function (uploadedFile) {
                                                            fileBase64 = '';
                                                            $$('VersionFileNameLabel').setHTML('');
                                                            var reader = new FileReader();
                                                            reader.onload = function () {
                                                                // Skip if the file was replaced, or the window closed, before the read finished
                                                                if (!$$('VersionFile') || !$$('VersionFile').files.exists(uploadedFile.id)) {
                                                                    return;
                                                                }
                                                                fileBase64 = reader.result;
                                                                $$('VersionFileNameLabel').setHTML(
                                                                    _('Archivo seleccionado: ') + webix.template.escape(uploadedFile.name),
                                                                );
                                                            };
                                                            reader.readAsDataURL(uploadedFile.file);
                                                        },
                                                    },
                                                },
                                                {
                                                    view: 'template', // Shows the name of the currently selected file
                                                    id: 'VersionFileNameLabel',
                                                    borderless: true,
                                                    autoheight: true,
                                                    template: '',
                                                },
                                                {
                                                    cols: [
                                                        // Button layout
                                                        {
                                                            view: 'button', // Cancel button
                                                            value: _('Cancelar'), // Localized button text
                                                            click: function () {
                                                                // Click event to cancel
                                                                this.getTopParentView().hide(); // Hides the window
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button
                                                            type: 'form', // Button type
                                                            value: _('Guardar'), // Localized button text
                                                            click: function ($e) {
                                                                // Click event to save
                                                                var saveButton = this;
                                                                var encryptionValue = String(
                                                                    $$('addVersion').getValues().EncryptionValue || '',
                                                                ).trim();
                                                                if (!encryptionValue) {
                                                                    $$('addVersion').markInvalid('EncryptionValue');
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'),
                                                                    });
                                                                    return;
                                                                }
                                                                if (!fileBase64) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _('Debes adjuntar un archivo'),
                                                                    });
                                                                    return;
                                                                }
                                                                // Same as the edit popup: next consecutive version
                                                                var nextVersion = getNextVersion(version);
                                                                if (!nextVersion) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _('Ocurrio un error, comuniquese con soporte'),
                                                                    });
                                                                    return;
                                                                }
                                                                var payload = {
                                                                    Id: id, // Document ID
                                                                    Version: nextVersion,
                                                                    EncryptionMethod: encryptionMethod, // From GetDocuments
                                                                    EncryptionValue: encryptionValue,
                                                                    File: fileBase64, // Same variable and format as AddDocument
                                                                };
                                                                saveButton.disable(); // Prevents a second submit while AddVersion is in progress
                                                                webix
                                                                    .ajax() // AJAX request to save version
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() + // API URL from config
                                                                            'RegisteredDocument/AddVersion',
                                                                        JSON.stringify(payload), // JSON payload
                                                                        {
                                                                            error: function (text, data, XmlHttpRequest) {
                                                                                // Error callback: window stays open with the entered data
                                                                                saveButton.enable();
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (text, data, XmlHttpRequest) {
                                                                                // Success callback
                                                                                saveButton.enable();
                                                                                var resp = JSON.parse(text); // Parse response
                                                                                if (resp.HasError) {
                                                                                    // Check for errors, window stays open with the entered data
                                                                                    webix.message({
                                                                                        title: _('¡Error!'), // Localized error title
                                                                                        type: 'alert-error', // Error message type
                                                                                        text: _(
                                                                                            'Ocurrio un error, comuniquese con soporte',
                                                                                        ), // Localized error text
                                                                                    });
                                                                                } else {
                                                                                    webix.message('Versión Agregada'); // Success message
                                                                                    version = nextVersion; // So a following AddVersion continues from this one
                                                                                    encryption = encryptionValue;
                                                                                    app.callEvent('version:id', [id, name, version, encryption, encryptionMethod]); // Reloads the versions table
                                                                                    app.callEvent('registeredDocument:reload', []); // Reloads the documents table (Version column)
                                                                                    saveButton.getTopParentView().hide(); // Hide the window only after a successful save
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    })
                                    .show(); // Show the window
                            },
                        },
                    ],
                },
                Table, // Including the Table component
                toolbar, // Including the toolbar
            ],
        };
        return {
            height: screen.width < 500 ? 350 : 0, // Set height based on screen width
            type: 'wide', // Layout type
            cols: [left], // Left column configuration
        };
    }
}

// FILE DOCUMENTED
